<app-fire-lightning-background>
  <div class="center-panel">
    <div>
      <p>Thank you for using the Sales<b>360°</b> Portal. We hope to see you again soon!</p>
      <p><a id="home" [href]="homeHref">Home</a></p>
    </div>
  </div>
</app-fire-lightning-background>
